import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IBotonBluetooth, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { LoginService } from '../../../../login/login.service';
import { BotonesBLEService } from '../../../../../auxiliares/servicios/http/botones-ble.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';

@Component({
  selector: 'app-botones-ble',
  templateUrl: './listado-boton-ble.component.html',
  styleUrl: './listado-boton-ble.component.scss',
  standalone: false,
})
export class ListadoBotonBLEComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(BotonesBLEService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);

  public clientePropio = LoginService.getCliente();

  //// Tabla nueva
  public name = 'ListadoBotonBLEComponent';
  public botonesBLE?: IBotonBluetooth[];
  public botonesBLE$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IBotonBluetooth>[];

  private childrenLevel?: number = -1;
  private includeChildren?: boolean;

  public search: IRegExpSearch = {
    fields: ['mac', 'serialNumber'],
  };

  public populate: IPopulate[] = [
    {
      path: 'cliente',
    },
    {
      path: 'modeloDispositivo',
      populate: {
        path: 'codigos',
        populate: {
          path: 'codigos.categoriaEvento',
        },
      },
    },
  ];

  //FILTROS
  //Cliente
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    // filtroSelector: ['moduloBotonBLE'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  //Modelo
  public modelo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idModeloDispositivo',
    },
    label: 'Modelo',
    selectLabel: 'modeloDispositivo',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'modeloDispositivos',
    searchOn: ['modeloDispositivo'],
  };
  public filtros: IFiltroTabla[] = [this.modelo];

  //Query
  public filter: IFilter<IBotonBluetooth> = {};
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'name',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  //Listar
  public async listar(): Promise<void> {
    this.botonesBLE$?.unsubscribe();
    this.botonesBLE$ = this.lista2
      .botonBles(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.botonesBLE = data.datos;
      });
  }

  // Acciones

  public async eliminar(botonBLE: IBotonBluetooth) {
    const res = await this.dialogService.confirm(
      'Eliminar botón BLE',
      `¿Querés eliminar el botón ${botonBLE?.mac}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(botonBLE._id!);
      this.helper.notifSuccess('Botón BLE eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public detalles(botonBLE: IBotonBluetooth): void {
    this.navigator.navigate([
      'main/administracion/botones-ble/detalles',
      botonBLE._id,
    ]);
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IBotonBluetooth>[] = [
      //Fecha de Creación
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
        },
      },

      //mac
      {
        header: {
          label: 'MAC',
        },
        row: {
          html: (dato) =>
            dato.mac
              ? `<span class="tabla-codigo">${escaparHtml(dato.mac)}</span>`
              : '',
          noData: 'Sin MAC',
        },
      },

      //Serial number
      // {
      //   header: {
      //     label: 'Número serial',
      //   },
      //   row: {
      //     field: 'serialNumber',
      //   },
      // },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    //Serial number
    columnas.push(
      //Acciones
      {
        header: {
          label: 'Acciones',
        },
        row: {
          // Pocas acciones, sueltas: Ver detalle y Eliminar al final
          acciones: [
            {
              tipo: 'material',
              icon: 'visibility',
              tooltip: 'Ver detalle',
              click: (dato) => this.detalles(dato),
            },
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
              disabled: () =>
                !this.helper.tienePermiso(
                  'Administración - Eliminar botones Ble',
                ),
            },
          ],
        },
      },
    );
    this.columnas = columnas;
  }
  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.botonesBLE$?.unsubscribe();
  }
}
